var traceit = null;
(function ($) {
    traceit = function (v, condebug,app) {
        if (condebug) {
            console.log(v);
        } else {
            if ($('#trace').length === 0) {
                app.after("<div id='trace'><div id='traceinner'><strong>Trace statements</strong><br><br></div></div>");
            }

            if (typeof v === 'object') {
                $("#traceinner").append("[LOG] Begin object<br>");
                for (var property in v) {
                    $("#traceinner").append("[LOG] " + property + ' : ' + v[property] + "<br>");
                }
                $("#traceinner").append("[LOG] End object<br>"); 
            } else {
                $("#traceinner").append("[LOG] " + v + "<br>");
            }
        }
        $(window).trigger("changeMenu");

        return this;
    };
})(jQuery); 